import { render, staticRenderFns } from "./SearchNumeroPermis.vue?vue&type=template&id=423e6253"
import script from "./SearchNumeroPermis.vue?vue&type=script&lang=js"
export * from "./SearchNumeroPermis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports